export default __webpack_public_path__ + "media/images/logo_white_text-28beec04.svg";